export default function(num) {
    return Number(num).toLocaleString(
            'en-US',
            { style:'decimal', maximumFractionDigits:3, }
            )
//    return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}

